module.exports = __webpack_public_path__ + "static/media/ChancesHBP.e90c69e3.png";